import { ModelBase, NeoModel, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class UndoAwardResponseCommand extends ModelBase {

    public participantOfferIds: number[] | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<UndoAwardResponseCommand>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New undo Award Response command";
        } else {
            return "Undo Award Response Command";
        }
    }
}